import React from 'react';

import { HomePageComponent } from '@bingads-webui-campaign-react/ads-studio-app-components';
import { notificationApi } from '../../adapters/get-notification';

export const HomePage = props => (
  <HomePageComponent {...props} notificationApi={notificationApi} />
);
